/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CustomFormNode.vue?vue&type=template&id=6a772241&scoped=true&"
import script from "./CustomFormNode.vue?vue&type=script&lang=js&"
export * from "./CustomFormNode.vue?vue&type=script&lang=js&"
import style0 from "./CustomFormNode.vue?vue&type=style&index=0&id=6a772241&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a772241",
  null
  
)

export default component.exports